import { AttributesMixin, define, Model, type } from "@type-r/models";
import { getAuthorizationBearer, getPlatformCode, restfulIO } from "./endpoint";
import { ChannelType, FlowType, EncryptionMethod } from "./lookups";

export interface ConnectionStatus extends AttributesMixin<typeof ConnectionStatus> { }

@define
export class ConnectionStatus extends Model {
  static attributes = {
    isActive: Boolean
  }
}

export interface CompanyName extends AttributesMixin<typeof CompanyName> { }

@define
export class CompanyName extends Model {
  static attributes = {
    name: String
  }
}

export interface Connection extends AttributesMixin<typeof Connection> { }

@define
export class Connection extends Model {
  static attributes = {
    name: String,
    channelType: type(ChannelType),
    flowType: type(FlowType),
    company: type(CompanyName),
    encryptionMethod: type(EncryptionMethod),
    isValidConnection: Boolean,
    isActive: Boolean,
    createdBy: String,
    createdOn: Date,
    updatedOn: type(Date).null,
    fileCodes: type(Array)
  }

  async switchStatus(): Promise<ConnectionStatus> {
    const url = `api/v1/ingest/connections/${this.id}/switch`;

    const payload = {
      id: this.id,
      isActive: !this.isActive
    };

    const response = await fetch(url, {
      method: 'PUT',
      headers: new Headers({
        "Authorization": getAuthorizationBearer(),
        'Content-Type': 'application/json',
        'X-Platform-Code': getPlatformCode()
      }),
      body: JSON.stringify(payload)
    });

    if (response.status < 200 || response.status >= 300) {
      let error = response.statusText || `HTTP Error ${response.status}`;
      await response.json()
        .then(e => error = e.error)
        .catch(e => console.error('Cannot parse response data'));
      throw new Error(error);
    }

    const json = await response.json();
    this.set({
      isActive: json.isActive
    });
    return this;
  }
}

export interface Connections extends AttributesMixin<typeof Connections> { }

@define
export class Connections extends Model {
  static endpoint = restfulIO('api/v1/ingest/connections');

  static attributes = {
    items: [Connection],
    count: Number
  }
}